import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import { initTheme } from './lib/theme';
import { MAC_APP } from './lib/mac';
import './styles/globals.css';
import './styles/app.css';

// Inside the Mac app's window (lib/mac.ts); index.html's pre-paint
// script sets the same class, this keeps it if that script changes.
if (MAC_APP) document.documentElement.classList.add('mac-app');
initTheme();

// A data router (not <BrowserRouter>) because the expense and settle
// forms guard unsaved changes with useBlocker, which only works under
// one. App keeps its own <Routes> as descendants of this single splat
// route, so routing itself is unchanged.
const router = createBrowserRouter([{ path: '*', element: <App /> }], {
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  </React.StrictMode>,
);
